































































































































import {Vue, Component} from 'vue-property-decorator';
import ClickOutside from 'vue-click-outside';
import {toI18n} from '@/utils/commonUtils';

@Component({
  directives: {
    ClickOutside
  }
})
export default class ProductPopSearchSlotPanel extends Vue {
  public showCustomProperty: boolean = true;
  public isExistcustomProperty: boolean = false;
  public isShowNoticeBox = false;
  public noticeBoxHTML = '';

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_SEARCH_' + needToI18nStr));
  }
}
